import { authService } from '@/services/AuthService'
// import router from '@/router'

const user = JSON.parse(localStorage.getItem('user'))
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: null }

export default {
  state: initialState,
  mutations: {
    loginRequest (state, user) {
      state.status = { loggingIn: true }
      state.user = user
    },
    loginSuccess (state, user) {
      state.status = { loggedIn: true }
      state.user = user
    },
    loginFailure (state) {
      state.status = {}
      state.user = null
    },
    logout (state) {
      state.status = {}
      state.user = null
    }
  },
  actions: {
    logIn ({ dispatch, commit }, { login, password }) {
      commit('loginRequest', { login })

      return authService.login(login, password)
        .then(
          user => {
            commit('loginSuccess', user)
            return 'success'
          },
          error => {
            commit('loginFailure', error)
            return { status: 'failed', message: typeof error === 'string' ? error : 'login failed' }
          }
        )
    },
    logout ({ commit }) {
      authService.logout()
      commit('logout')
    }
  },
  getters: {
    isLoggining (state) {
      return !!state.status.loggingIn
    },
    isLogged (state) {
      return !!state.status.loggedIn
    },
    user (state) {
      return state.user
    }
  }
}
